import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { runFlowTaskChangeSchedule } from '../actions/RunFlowTaskMenuActions';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';
import { ManageRunFlowTaskActions, userHasManageRunFlowTaskPermissions } from '../utils/FlowTaskActionUtils';

export const RunFlowTaskChangeScheduleAction: IEntityAction<RunFlowTaskInfo, ManageRunFlowTaskActions> = {
  name: EntityActionNames.TasksChangeSchedule,
  translateName: Messages.changeSchedule_action,
  isVisible: (targetItems: RunFlowTaskInfo[], state: AppState) => {
    return targetItems.length > 0;
  },
  isClickable: (availableActions: ManageRunFlowTaskActions, targetItems: RunFlowTaskInfo[]) => {
    return userHasManageRunFlowTaskPermissions(availableActions);
  },
  createReduxAction: (targetItems: RunFlowTaskInfo[]) => runFlowTaskChangeSchedule(targetItems)
};
